// extracted by mini-css-extract-plugin
export default {"modalOverlay":"successModal_modalOverlay__TveQh","modalContent":"successModal_modalContent__bWxu0","img":"successModal_img__q1u3U","closeButton":"successModal_closeButton__EiWue"};